import React from "react";
import { TCText } from "../TCText/TCText";
import { CourtZone } from "../courtZone/CourtZone";
import { useCourtBookingStore } from "../../stores/StoreContext";
import { observer } from "mobx-react-lite";
import { CourtId, CourtType } from "../../types/types";
import {
  TOTAL_PLAYERS_IN_MATCH,
  TOTAL_PLAYERS_IN_MATCH_SINGLES,
} from "../../utils/data";
import { RemovePlayersModal } from "../modal/removePlayersModal/RemovePlayersModal";

type props = {};

export const SelectCourtType: React.FC<props> = observer(() => {
  const courtBookingStore = useCourtBookingStore();

  return (
    <div style={{ marginTop: 20 }}>
      <TCText
        style={{
          fontWeight: 500,
          fontSize: 12,
          color: "black",
          marginBottom: 10,
        }}
        value="Select court type"
      />
      <div
        style={{
          display: "flex",
          overflowX: "auto",
          gap: "10px", // Adds spacing between items
          scrollbarWidth: "none", // Hides scrollbar in Firefox
          msOverflowStyle: "none", // Hides scrollbar in IE
          whiteSpace: "nowrap", // Prevents wrapping
        }}>
        {courtBookingStore.courts.map((court: CourtType) => (
          <CourtZone
            key={court.id}
            title={court.title}
            isSelected={court.id === courtBookingStore.selectedCourt?.id}
            onPress={() => {
              if (court.id === CourtId.Singles) {
                courtBookingStore.setTotalPlayersInMatch(
                  TOTAL_PLAYERS_IN_MATCH_SINGLES
                );
              } else {
                courtBookingStore.setTotalPlayersInMatch(
                  TOTAL_PLAYERS_IN_MATCH
                );
                courtBookingStore.setSelectedCourt(court);
              }
            }}
          />
        ))}
      </div>
      <RemovePlayersModal />
    </div>
  );
});
